import React, { useState, useEffect } from 'react';
import './MemorialPage.css';
import image1 from '../../../assets/2.png';
import image2 from '../../../assets/3.png';
import image3 from '../../../assets/111.peg.jpeg';
import image4 from '../../../assets/5.jpg';

export default function MemorialPage() {
  const images = [image3,image1, image2, image4];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      // نبدأ تأثير التلاشي قبل تغيير الصورة
      setFade(false);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % images.length);
        setFade(true);
      }, 500); // نصف ثانية لتأثير التلاشي
    }, 5000); // تغيير كل 5 ثواني

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="memorial-container">
      <h1 className="memorial-title">رثاء</h1>

      <div className="tribute-text">
        <p>
          رحل عن عالمنا، لكن روحه لا تزال حاضرة في قلوبنا . ندعو له ولجميع المسلمين
          بالجنة ونعيمها، وبنور لا ينقطع في قبورهم. رحمهم الله رحمة واسعة وجمعنا
          بهم في دار الخلود.
        </p>
      </div>

      <div className="slider-container">
        <img
          src={images[currentIndex]}
          alt="memorial"
          className={`slider-image ${fade ? 'fade-in' : 'fade-out'}`}
        />
      </div>
    </div>
  );
}
